import { render, staticRenderFns } from "./ExportProductTransfer.vue?vue&type=template&id=44fa23cd&scoped=true&"
import script from "./ExportProductTransfer.vue?vue&type=script&lang=js&"
export * from "./ExportProductTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ExportProductTransfer.vue?vue&type=style&index=0&id=44fa23cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa23cd",
  null
  
)

export default component.exports